import { Box } from '@mui/material';
import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { useSearchParams } from 'react-router-dom';

import { useFeatureFlagSplit } from '@verantos-dev/app-state-base';
import { PageHeader } from '@verantos-dev/shared-components';

import { ConceptGroupsGrid } from './components/ConceptGroupsGrid';
import { ConceptGroupsListDialogs } from './components/ConceptGroupsListDialogs';
import { ConceptGroupWorkflowDialog } from './containers/ConceptGroupWorkflowDialog';
import { ConceptGroupsListDialogProvider } from './context/ConceptGroupsListDialogContext';

// TODO: cleanup with concept_groups_list_create_hide ff
const FF_HIDE_CREATE = 'concept_groups_list_create_hide';

export const ConceptGroupsListPage = () => {
  const intl = useIntl();
  const [searchParams, setSearchParams] = useSearchParams();
  const [openConceptGroupDialog, setOpenConceptGroupDialog] = useState(false);
  const hideCreateConceptGroup = useFeatureFlagSplit(FF_HIDE_CREATE);

  useEffect(() => {
    if (searchParams.get('upload') === 'true') {
      setOpenConceptGroupDialog(true);
      searchParams.delete('upload');
      setSearchParams(searchParams, { replace: true });
    }
  }, [searchParams, setSearchParams]);

  return (
    <ConceptGroupsListDialogProvider>
      <Box data-testid="concept-groups-list-page">
        <PageHeader
          id="concept-groups-page-header"
          data-testid="concept-groups-page-header"
          pageTitle={intl.formatMessage({ id: 'conceptGroups.pageTitle' })}
          actions={
            hideCreateConceptGroup
              ? []
              : [
                  {
                    id: 'create-concept-group',
                    label: intl.formatMessage({ id: 'conceptGroups.actions.createConceptGroup' }),
                    onClickHandler: () => setOpenConceptGroupDialog(true),
                    btnType: 'primary',
                    startIcon: 'add',
                  },
                ]
          }
        />
        <ConceptGroupsGrid />
        {openConceptGroupDialog && (
          <ConceptGroupWorkflowDialog onClose={() => setOpenConceptGroupDialog(false)} />
        )}
        <ConceptGroupsListDialogs />
      </Box>
    </ConceptGroupsListDialogProvider>
  );
};

export default ConceptGroupsListPage;
